@if (inputType === 'checkbox') {
<div class="field-block checkbox-field" [class.field-block-full]="fullWidth">
  <div class="form-check">
    <input class="form-check-input" [formControlName]="controlName" [id]="controlId" type="checkbox" />
    <label class="form-check-label" [for]="controlId">{{ labelKey | translate }}</label>
  </div>

  <ng-content />
</div>
} @else {
<div class="field-block" [class.field-block-full]="fullWidth">
  <label class="form-label" [for]="controlId">{{ labelKey | translate }}</label>

  @if (controlName) {
  <input class="form-control" [class.is-invalid]="invalid" [formControlName]="controlName" [id]="controlId"
    [readonly]="readonly" [type]="inputType" />
  } @else {
  <input class="form-control" [class.is-invalid]="invalid" [id]="controlId" [readonly]="readonly" [type]="inputType"
    [value]="value ?? ''" />
  }

  <ng-content />
</div>
}
